import React, { Fragment, useState, useEffect } from "react";
//
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
} from "@material-ui/core";
//
import Changelog from "containers/components/changelog/Changelog";

export default function ChangelogDialog() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const version = localStorage.getItem("appVersion");

        const currentVersion = process.env.REACT_APP_VERSION;
        if (version !== currentVersion) {
            setOpen(true);
            localStorage.setItem("appVersion", currentVersion);
        }
    }, []);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Fragment>
            <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title">
                <DialogContent>
                    <Changelog />
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}
